export const adaptInfraDeploymentResponse = (response) => {
  // Handle both old and new response structures
  // New structure: response.response is an array
  // Old structure: response.response is an object
  const infraDeploymentResponse = Array.isArray(response?.response)
    ? response?.response?.[0] || {}
    : response?.response || {};
  const infraResources = infraDeploymentResponse?.infraResources || '{}';
  return {
    eksCloudResourceUrl: infraResources?.k8sCloudResourceUrl,
    ecrepo: infraResources?.ec2RepoCloudResourceUrl,
    vpcCloudResourceUrl: infraResources?.vpcCloudResourceUrl,
    cloudLocationId: infraDeploymentResponse?.cloudLocationId,
  };
};

export const adaptInfraResourcesResponse = (response) => {
  return response?.[0]?.resourceInfo?.parameters?.repoTailscaleIp?.value;
};

export const adaptSqsResourceResponse = (response) => {
  return Array.isArray(response) ? response : null;
};

export const adaptVpcResourceResponse = (response) => {
  return Array.isArray(response) ? response : null;
};
